var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 34,
    viewBox: "0 0 30 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H25C27.4853 0.5 29.5 2.51472 29.5 5V19C29.5 21.4853 27.4853 23.5 25 23.5H0.5V0.5Z",
    fill: "#EBF2F7",
    stroke: "#DFE2E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4C12.8189 4 11.1755 4.49852 9.77766 5.43251C8.37984 6.3665 7.29037 7.69402 6.64703 9.24719C6.00368 10.8004 5.83535 12.5094 6.16333 14.1583C6.4913 15.8071 7.30085 17.3217 8.4896 18.5104C9.67834 19.6992 11.1929 20.5087 12.8417 20.8367C14.4906 21.1646 16.1996 20.9963 17.7528 20.353C19.306 19.7096 20.6335 18.6202 21.5675 17.2223C22.5015 15.8245 23 14.1811 23 12.5C23 10.2457 22.1045 8.08365 20.5104 6.48959C18.9164 4.89553 16.7543 4 14.5 4ZM15.2083 12.8067L11.6291 15.05L10.8776 13.8458L13.7917 12.0219V8.25H15.2083V12.8067Z",
    fill: "#969BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerImg);
export default __webpack_public_path__ + "static/media/TimerImg.aa06b821dbca20409f4619029a2dc5a5.svg";
export { ForwardRef as ReactComponent };